import Vue from 'vue'
import VueToastr2 from 'vue-toastr-2'

window.toastr = require('toastr')
Vue.use(VueToastr2)



// WEBPACK FOOTER //
// ./src/front/init/components/toastr.js